import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import { Label } from "../Label"
import { CheckboxContainer as Container } from "./styled"

/**
 * A checkbox with label.
 *
 * The component has an internal state but will respect initialChecked changes.
 */
const CheckBox = ({ id, label, initialChecked, disabled, name, value, handleChange, children, className }) => {
  const [checkedState, setCheckedState] = useState(Boolean(initialChecked))

  useEffect(() => {
    setCheckedState(Boolean(initialChecked))
  }, [initialChecked])

  const onChange = (event) => {
    const {
      target: { checked: isChecked },
    } = event

    if (typeof handleChange === "function") {
      handleChange({ checked: isChecked, id, name, value }, event)
    }

    setCheckedState(isChecked)
  }

  return (
    <Container className={className}>
      <input
        type="checkbox"
        id={id}
        name={name}
        value={value}
        checked={checkedState}
        disabled={disabled}
        onChange={onChange}
      />
      {children}
      {label && typeof label === "string" && (
        <Label disabled={disabled} htmlFor={id} $inline>
          {label}
        </Label>
      )}
    </Container>
  )
}

CheckBox.propTypes = {
  /**
   * Unique Id matching id of label tag. Will be passed on handleChange
   */
  id: PropTypes.string,
  /**
   * If present checkbox label with matching "for" with "id"
   */
  label: PropTypes.string,
  /**
   * If true disables label and component
   */
  disabled: PropTypes.bool,
  /**
   * Name that will be applied to input HTML-wise. Will be passed on handleChange
   */
  name: PropTypes.string,
  /**
   * Value that will be applied to HTML. Will be passed on handleChange
   */
  value: PropTypes.string,
  /**
   * The initial value of the checkbox, if change will change the state
   */
  initialChecked: PropTypes.bool,
  /**
   * If present fired with the checked state,id,name and value
   */
  handleChange: PropTypes.func,
}

export { CheckBox }
